<template>
  <div class="ticket-container">
    <paginaRingraziamento
      v-if="showPaginaRingraziamento" 
      :paginaRingraziamentoLogId="paginaRingraziamentoLogId"
      :setPaginaLoaderCallback="setPaginaLoaderCallback"
      :ticketId="ticketIdCreato">
    </paginaRingraziamento>
    <form v-if="showTicketForm" class="row g-3 needs-validation text-start" @submit="checkForm" :novalidate="novalidate">
    <ticketFormInputs ref="ticketFormInputs" :answerDetail="answerDetail"></ticketFormInputs>
    <fileUploaderList ref="fileListUploader"  :answerDetail="answerDetail" :ticketId="ticketIdCreato" />
     <div class="col-12 fw-bold">{{ intl[$store.state.lang]["privacy"] }} <span style="color: rgb(66, 139, 202);font-weight: bold">Privacy</span><span style="font-weight: bold">*:</span> </div>
      <div class="col-12">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="validationToc"
            aria-describedby="invalidToc"
            v-model="toc"
            required
          />
          <label class="form-check-label" for="validationToc">
            {{ intl[$store.state.lang]["terms-and-conditions"] }}
          </label>
          <div id="invalidToc" class="invalid-feedback">
             {{ intl[$store.state.lang]["terms-and-conditions-not-ok"] }}
          </div>
        </div>
      </div>
      
      <div class="col-12">
        <button class="btn btn-primary" :disabled="!this.toc" type="submit">
          {{ intl[$store.state.lang]["submit-request"] }}
        </button>
      </div>
      <span style="font-size: 14px; margin-top:10px"> {{ intl[$store.state.lang]["required-fields"] }}</span>
    </form>
    
  </div>
</template>

<script>
import intl from "./intl/intl";
import {apiUrls} from "../../api/apiUrls"
import axios from "axios";
import PaginaRingraziamento from "../paginaRingraziamento/PaginaRingraziamento.vue"
import TicketFormInputs from "../ticketFormInputs/TicketFormInputs.vue"
import FileUploaderList from "../fileUploaderList/FileUploaderList.vue"
export default {
  name: "ticket",
  components: {
    paginaRingraziamento: PaginaRingraziamento,
    ticketFormInputs:TicketFormInputs,
    fileUploaderList: FileUploaderList
   
  },
  mounted() {},
  props: {
      surveyId: {
        type: Number,
        default: null,
      },
      answerId: {
        type: Number,
        default: null,
      },
      getPaginaRingraziamentoCallback:{
        type: Function,
        default: (value) => {console.log("Pagina ringraziamento show: ",value)},
      },
      includiPaginaRingraziamento: {
        type: Boolean,
        default: true,
      },
      novalidate: {
            type: Boolean,
            default: true,
        },
      setPaginaLoaderCallback: {
        type: Function,
        default: (value) => {console.log("TICKET LOADER: ",value)},
      },
      onCreateTicketCallback: {
         type: Function,
         default: (response) => {console.log("Info ticket creato: ",response)},
      }
        
  },
  mounted() {
    this.addFormEventListener();
    this.getAnswerDetail()
  },
  beforeUnmount() {
    this.removeFormEventListener();
  },
  data: function () {
    return {
      intl: intl,
     
      toc: false,
      ticketLoader: false,
      ticketIdCreato: null,
      paginaRingraziamentoLogId: null,
      answerDetail: null
    };
  },
  methods: {
   
    checkForm(e) {
      if(e) e.preventDefault();
     
        this.$refs.fileListUploader && this.$refs.fileListUploader.checkAttachmentsOnCreateTicket()
        this.$refs["ticketFormInputs"] && this.$refs["ticketFormInputs"].checkFormInputsMessages()
        if(localStorage.getItem("survey_log_id_not_ended") && this.$refs["ticketFormInputs"].inputOblligatoriOk() &&  this.$refs.fileListUploader.fileObbligatoriDaCaricare().length === 0){
            this.ticketLoader = true
            axios
                  .post(apiUrls["create_ticket"], {
                      ...this.$refs["ticketFormInputs"].getInputParams(),
                      ...{
                      status: 0,
                      active: 1,
                      survey_ok: 'true',
                      num_sessione: localStorage.getItem(process.env.VUE_APP_TOKEN_ID),
                      broswer: navigator.userAgent,
                      survey_id: localStorage.getItem("survey_log_id_not_ended")}
                  })
                  .then((response) => {   
                      
                      this.paginaRingraziamentoLogId = localStorage.getItem("survey_log_id_not_ended")
                      
                      if(response.data){
                        this.onCreateTicketCallback(response)
                      }
                      this.ticketIdCreato = response.data.id    
                      this.ticketLoader = false
                   
                      if(this.$refs.fileListUploader && this.$refs.fileListUploader.uploadAll){
                        this.$refs.fileListUploader.uploadAll(this.ticketIdCreato)
                      }
                      if(this.$store.hasModule("questionarioStore-"+this.surveyId)){
                        this.$store.commit("questionarioStore-"+this.surveyId+"/doCloseQuiz")
                      } 
                  })
                  .catch((error) => {
                      
                      this.ticketLoader = false
                  });
        }
    
         
               
    },
    addFormEventListener() {
      var forms = document.querySelectorAll(
        ".ticket-container .needs-validation"
      );
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener(
          "submit",
          function (event) {
                 
            if (!form.checkValidity()) {             
              event.preventDefault();
              event.stopPropagation();
              
            }else{
              
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    getAnswerDetail() {
      if (this.answerId) {
        this.ticketLoader = true;
      
        axios
          .get(apiUrls["answer_detail"] + this.answerId)
          .then((response) => {
            if (
              response.data
            ) {
              this.answerDetail = response.data
            }
          
        
            this.ticketLoader = false;
          })
          .catch((error) => {
          
       
            this.ticketLoader = false;
          });
      }
    },
    removeFormEventListener() {
      var forms = document.querySelectorAll(
        ".ticket-container .needs-validation"
      );
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.removeEventListener(
          "submit",
          function (event) {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }

            form.classList.add("was-validated");
          },
          false
        );
      });
    },
  },
  watch: {
    ticketLoader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        this.setPaginaLoaderCallback({ticketLoader: newValue})
                    }                
                },
                deep : true
        }

  },
  computed: {
      showPaginaRingraziamento: function () {
        this.getPaginaRingraziamentoCallback(this.includiPaginaRingraziamento && this.ticketIdCreato !== null)
      return this.includiPaginaRingraziamento && this.ticketIdCreato !== null
  },
  showTicketForm: function () {
     
      return !this.includiPaginaRingraziamento || (this.includiPaginaRingraziamento && this.ticketIdCreato === null)
  },
    },
  
};
</script>
